import { Bell } from "lucide-react";
import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLocationData } from "@/hooks/useLocationData";
import { alertLabel } from "@/lib/locationPresentation";
import { timeAgo } from "@/lib/format";
export function NotificationsMenu() {
  const data = useLocationData();
  const alerts = data.listAlerts({ status: "open" });
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="focus-ring relative flex size-8 shrink-0 items-center justify-center rounded-sm text-ink-2 hover:bg-sidebar-accent"
          aria-label={`Notifications, ${alerts.length} open alerts`}
        >
          <Bell className="size-4" />
          {!!alerts.length && (
            <span className="absolute right-1.5 top-1.5 size-2 rounded-full bg-signal ring-2 ring-sidebar" />
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-[min(24rem,calc(100vw-1rem))] p-0"
      >
        <div className="border-b border-line px-3 py-3 text-sm font-medium">
          Open alerts{" "}
          <span className="ml-2 font-mono text-ink-3">{alerts.length}</span>
        </div>
        <div className="max-h-96 overflow-y-auto p-1">
          {alerts.slice(0, 6).map((a) => (
            <DropdownMenuItem key={a.id} asChild className="h-auto py-3">
              <Link
                to={`/alerts/${a.id}`}
                className="flex flex-col items-start gap-1"
              >
                <span className="text-sm text-ink">{alertLabel(data, a)}</span>
                <span className="font-mono text-xs text-ink-3">
                  {timeAgo(a.at, data.now)}
                </span>
              </Link>
            </DropdownMenuItem>
          ))}
          {!alerts.length && (
            <p className="p-4 text-sm text-ink-3">
              All alerts have been reviewed.
            </p>
          )}
        </div>
        <div className="border-t border-line p-1">
          <DropdownMenuItem asChild>
            <Link to="/alerts">View all alerts</Link>
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
